export default "__VITE_ASSET__C0yLtP2f__"